import React, { useState, useRef, useEffect } from "react";
import InputText from "./InputText";
import DropdownPortal from "../Elements/DropdownPortal";
import DropdownInput from "./DropdownInput";
import PropTypes from "prop-types";

const InputCurrency = React.forwardRef(
  (
    {
      label,
      placeholder,
      name,
      setCurrency,
      onChange,
      error,
      currencies = [],
      value: defaultValue,
    },
    ref
  ) => {
    const [value, setValue] = useState(defaultValue);
    const [currencyDropdown, setCurrencyDropdown] = useState(false);
    const [filteredCurrency, setFilteredCurrency] = useState(currencies);
    const [dropdownPosition, setDropdownPosition] = useState({
      top: 0,
      left: 0,
      width: 0,
    });

    const internalRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
      setValue(defaultValue);
    }, [defaultValue]);
    useEffect(() => {
      setFilteredCurrency(
        currencies.includes(value)
          ? currencies
          : currencies.filter((c) =>
              c.toLowerCase().includes(value?.toLowerCase() || "")
            )
      );
    }, [value, currencies.length]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          internalRef.current &&
          !internalRef.current.contains(event.target) &&
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setCurrencyDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleFocus = () => {
      if (internalRef.current) {
        const rect = internalRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
        });
        setCurrencyDropdown(true);
      }
    };

    const handleSelect = (currency) => {
      if (setCurrency) {
        setCurrency(currency);
        
      }
      setCurrencyDropdown(false);
    };

    return (
      <div className="relative w-full">
        <InputText
          ref={(node) => {
            internalRef.current = node;
            if (typeof ref === "function") {
              ref(node);
            } else if (ref) {
              ref.current = node;
            }
          }}
          label={label}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e);
          }}
          onFocus={handleFocus}
          autoComplete="off"
          error={error}
        />
        {currencyDropdown && (
          <DropdownPortal>
            <ul
              ref={dropdownRef}
              className="fixed z-[99999] bg-white card-base-border rounded-md shadow-lg mt-1 max-h-48 overflow-y-auto"
              style={{
                top: dropdownPosition.top,
                left: dropdownPosition.left,
                width: dropdownPosition.width,
              }}
            >
              {filteredCurrency.map((currency) => (
                <DropdownInput
                  key={currency}
                  value={currency}
                  onSelect={() => handleSelect(currency)}
                />
              ))}
            </ul>
          </DropdownPortal>
        )}
      </div>
    );
  }
);

InputCurrency.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  setCurrency: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.string,
  currencies: PropTypes.arrayOf(PropTypes.string),
};

InputCurrency.displayName = "InputCurrency";

export default InputCurrency;
